<div class="bf-gallery-grid">

  <section class="bf-gallery-grid__grid-section">

    <div class="bf-gallery-grid__grid">

      @for (image of images(); track image.id; let i = $index) {
        <button
          type="button"
          class="bf-gallery-grid__thumb"
          [attr.aria-label]="image.caption ?? 'Kép megnyitása'"
          (click)="onImageClick(image, i)"
        >
          <img
            [src]="image.thumbUrl"
            [alt]="image.caption ?? ''"
            loading="lazy"
            class="bf-gallery-grid__thumb-img"
          />

          @if (image.linkUrl && !openExternalLinksDirectly) {
            <span
              class="bf-gallery-grid__external-link"
              role="button"
              tabindex="0"
              aria-label="Megnyitás külső oldalon"
              (click)="onExternalLinkButtonClick($event, image.linkUrl)"
              (keydown.enter)="onExternalLinkButtonClick($event, image.linkUrl)"
            >
              ↗
            </span>
          }
        </button>
      }

    </div>

  </section>


  @if (lightboxOpen()) {
    <div
      class="bf-lightbox"
      (click)="closeLightbox()"
    >

      <button
        type="button"
        class="bf-lightbox__close"
        aria-label="Bezárás"
        (click)="closeLightbox()"
      >
        ✕
      </button>

      <button
        type="button"
        class="bf-lightbox__nav bf-lightbox__nav--prev"
        aria-label="Előző kép"
        (click)="$event.stopPropagation(); showPrevious()"
      >
        ‹
      </button>

      <figure
        class="bf-lightbox__figure"
        (click)="$event.stopPropagation()"
      >
        <img
          [src]="images()[currentIndex()].fullUrl"
          [alt]="images()[currentIndex()].caption ?? ''"
          class="bf-lightbox__image"
        />

        @if (images()[currentIndex()].caption) {
          <figcaption class="bf-lightbox__caption">
            {{ images()[currentIndex()].caption }}

            @if (images()[currentIndex()].linkUrl) {
              <a
                [href]="images()[currentIndex()].linkUrl"
                target="_blank"
                rel="noopener"
                class="bf-lightbox__caption-link"
              >
                Megnyitás külső oldalon ↗
              </a>
            }
          </figcaption>
        }
      </figure>

      <button
        type="button"
        class="bf-lightbox__nav bf-lightbox__nav--next"
        aria-label="Következő kép"
        (click)="$event.stopPropagation(); showNext()"
      >
        ›
      </button>

    </div>
  }

</div>
